import { icons, logos } from '../images';

const platformIcons = {
  facebookmessenger: logos['facebook-messenger'],
  instagram: logos['instagram'],
  apexchat: logos['apexchat'],
  sitestaffchat: logos['sitestaffchat'],
  reviewloop: icons['icon-reviewloop'],
};

const typeIcons = {
  call: 'PhoneCall',
  phone_call: 'PhoneCall',
  phone: 'PhoneCall',
  email: 'Email',
  note: 'Notes',
  text: 'Message',
  todo: 'Todos',
  form: 'WebForm',
  won: 'Won',
  lost: 'Lost',
  web_form: 'WebForm',
};

const getMessageSVG = (message, options = {}) => {
  const type = String(typeof message === 'string' ? message : message.type)
    .replace(/s$/, '')
    .toLowerCase();
  const platformCode = message.platform_code || (message.platform || {}).code;

  if (platformIcons[platformCode]) {
    return platformIcons[platformCode];
  }

  return typeIcons[type];
};

export default getMessageSVG;
